import React, { useEffect, useState } from "react";
import { Container } from "./style";
import TextArea from "../../../../components/FormElement/TextArea";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import DatePicker from "../../../../components/FormElement/DatePicker";
import LangTab from "../../../../components/FormElement/LangTab";
import { useFormik } from "formik";
import { useShowAlert } from "../../../../hooks/useAlerts";
import * as Yup from "yup";
import Spinner from "../../../../components/Spinner/FullScreen";
import service from "../../../../services/news";
import { useHideModal } from "../../../../hooks";

const Form = ({ id, fetch }) => {
  const { hideModal } = useHideModal();
  const [language, setLanguage] = useState("UZL");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    date: Yup.string().required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      date: null,
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);
      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);
      formData.append("date", values.date);
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`files`, el.originFileObj);
        }
      });
      setLoading(true);
      if (id) {
        service
          .update(id, formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      service
        .getOne(id)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },
            desc: {
              UZL: resp?.desc?.UZL,
              UZK: resp?.desc?.UZK,
              RUS: resp?.desc?.RUS,
              ENG: resp?.desc?.ENG,
            },
            date: resp?.date,
          });
          setFileList(() =>
            resp?.media?.map((el) => {
              return el;
            })
          );
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  const onLangChange = (key) => {
    setLanguage(key);
  };

  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <TextArea
          id="title"
          name="title"
          label="Sarlavha"
          width={100}
          placeholder="Yangilik sarlavhasi"
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? "error" : ""}
          height={"60px"}
        />
        <TextArea
          id="desc"
          name="desc"
          label="Tavsifi"
          width={100}
          placeholder="Yangilik tavsifi"
          onChange={(e) => {
            formik.setFieldValue(`desc.${language}`, e.target.value);
          }}
          value={formik.values?.desc[language]}
          status={formik?.errors?.desc && formik.touched.desc ? "error" : ""}
          height={"120px"}
        />
        <DatePicker
          label="Sana"
          value={formik?.values?.date || null}
          onChange={(date) => formik.setFieldValue("date", date)}
          status={formik?.errors?.date && formik.touched.date ? "error" : ""}
        />
        <div className="upload-wrapper">
          <ImageUpload
            maxCount={10}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={status && !fileList?.length ? true : false}
          />
        </div>
        <Button
          text={id ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};

export default Form;
